import { defineMessages } from 'react-intl';

export default defineMessages({
  exploreThisChannel: {
    id: 'widget.home-view-mobile.explore-this-channel',
    defaultMessage: 'Explore this channel',
  },
});



// WEBPACK FOOTER //
// ./src/widget/views/mobile/translations.js